import { BrowserRouter, Route, Routes } from "react-router-dom";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Home from "./components/Home";
import Resume from "./components/Resume";
import { lazy, Suspense } from "react";
const Webdesigning = lazy(() => import("./components/Webdesigning"));
const Fullsatck = lazy(() => import("./components/Fullsatck"));
const Inpeace = lazy(() => import("./components/Inpeace"));
const FoodTube = lazy(() => import("./components/FoodTube"));
const Easytraveller = lazy(() => import("./components/Easytraveller"));
const GoEasyShop = lazy(() => import("./components/GoEasyShop"));

function App() {
  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/portfolio"
          element={
            <Suspense fallback={<div className="bg-black min-h-screen"></div>}>
              <Webdesigning />
            </Suspense>
          }
        />
        <Route
          path="/inpeace"
          element={
            <Suspense fallback={<div className="bg-black min-h-screen"></div>}>
              <Inpeace />
            </Suspense>
          }
        />
        <Route
          path="/foodTube"
          element={
            <Suspense fallback={<div className="bg-black min-h-screen"></div>}>
              <FoodTube />
            </Suspense>
          }
        />
        <Route
          path="/easyTravel"
          element={
            <Suspense fallback={<div className="bg-black min-h-screen"></div>}>
              <Easytraveller />
            </Suspense>
          }
        />
        <Route
          path="/projects"
          element={
            <Suspense fallback={<h2>...Loading</h2>}>
              <Fullsatck />
            </Suspense>
          }
        />
        <Route
          path="/goeasy"
          element={
            <Suspense fallback={<h2>...Loading</h2>}>
              <GoEasyShop />
            </Suspense>
          }
        />
        <Route path="/resume" element={<Resume />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
